import React, { Component } from 'react';

const TIME_FOR_REFRESHING_ACCESS = 3300000; // 55 minutes in ms
const FIVE_MINUTES_SAFE_INTERVAL = 300; // 5 minutes in seconds

class TokenListener extends React.PureComponent {
  intervalId = null;
  result = null

  componentDidMount() {
    const hasAuth = localStorage.getItem('auth') ? true : false;
    const hasPFM2SessionId = localStorage.getItem('pfm2SessionId_customerId') ? true : false;
    if (!hasAuth && hasPFM2SessionId) {
      console.info('TokenListener will not start because this is a login through PFM Portal.');
      return;
    }

    console.info('Starting TokenListener');
    this.start();
  }

  componentWillUnmount() {
    this.stop();
  }

  start() {
    if (this.intervalId) {
      return;
    }

    const { auth } = this.props;
    this.intervalId = setInterval(async () => {
      this.result = await auth.handleRefreshToken();

      if (this.result) {
        const timeForRefresh = this.result - FIVE_MINUTES_SAFE_INTERVAL;

        if ((timeForRefresh * 1000) !== TIME_FOR_REFRESHING_ACCESS) {
          console.error('timeForRefresh is different from TIME_FOR_REFRESHING_ACCESS', timeForRefresh);
          this.stop();
        }
      }
    }, TIME_FOR_REFRESHING_ACCESS);
  }

  stop() {
    if (!this.intervalId) {
      return;
    }

    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  render() {
    return null;
  }
}

export default TokenListener;
